import { render, staticRenderFns } from "./zbxcjList.vue?vue&type=template&id=0a4c0b13&scoped=true&"
import script from "./zbxcjList.vue?vue&type=script&lang=js&"
export * from "./zbxcjList.vue?vue&type=script&lang=js&"
import style0 from "./zbxcjList.vue?vue&type=style&index=0&id=0a4c0b13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c0b13",
  null
  
)

export default component.exports